module.exports = __webpack_public_path__ + "static/media/HomeRoll_Roof_CorrIronRoof.53e94c42.jpg";